
import { defineComponent } from '@nuxtjs/composition-api';
import ProductPreviewInformation from '~/domains/product/components/ProductPreviewInformation';
import ProductPreviewSlider from '~/domains/product/components/ProductPreviewSlider';
import ProductPreviewMobileCaption from '~/domains/product/components/ProductPreviewMobileCaption';

export default defineComponent({
  name: 'ProductPreviewSection',
  components: {
    ProductPreviewMobileCaption,
    ProductPreviewSlider,
    ProductPreviewInformation,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    productDocuments: {
      type: Array,
      default: () => [],
    },
    productUserGuides: {
      type: Array,
      default: () => [],
    },
    isLoadingDocuments: {
      type: Boolean,
      default: false,
    },
    isLoadingProduct: {
      type: Boolean,
      default: false,
    },
  },
});
